import { SimpleGrid } from '@joinrepublic/dls-ui-kit';

import { CardDealPlaceholder } from '@r-client/republic/ui/offerings';

import {
  GRID_BLEED,
  GRID_COLUMNS,
  GRID_SPACING_X,
  GRID_SPACING_Y,
  LOADING_LABEL,
  SKELETON_CARD_COUNT,
} from '../constants';

export const OfferingsGridSkeleton = () => {
  return (
    <SimpleGrid
      role="status"
      aria-label={LOADING_LABEL}
      mx={GRID_BLEED}
      columns={GRID_COLUMNS}
      spacingX={GRID_SPACING_X}
      spacingY={GRID_SPACING_Y}
    >
      {Array.from({ length: SKELETON_CARD_COUNT }, (_, index) => (
        <CardDealPlaceholder key={index} />
      ))}
    </SimpleGrid>
  );
};
